import React from 'react';

import Box, { TBoxProps } from '../Box/Box';
import { TLinkBase } from './LinkBase';

type TMaskedLinkProps = {
  href: string;
  onClick?: TBoxProps['onClick'];
  className?: TBoxProps['className'];
  children?: TBoxProps['children'];
  kind?: TLinkBase['kind'];
  target?: TLinkBase['target'];
  rel?: TLinkBase['rel'];
  role?: TLinkBase['role'];
} & React.HTMLAttributes<any>;

/**
 * MaskedLink Component for 'hiding' links from search engines,
 * to optimise SEO crawl budget
 * Add href to the anchor tag on human interaction
 * Why is it implemented this way? https://jira.es.ecg.tools/browse/BNL-14059
 */
const MaskedLink = ({ href, kind, role, ...props }: TMaskedLinkProps) => {
  const [humanInteraction, setHumanInteraction] = React.useState<boolean>(false);
  const onHumanInteraction = () => setHumanInteraction(true);

  return (
    <Box
      as="a"
      href={humanInteraction ? href : void 0}
      onTouchStart={onHumanInteraction}
      onMouseEnter={onHumanInteraction}
      tabIndex={0}
      onFocus={onHumanInteraction}
      name="Link"
      modifiers={kind ?? 'isolated'}
      role={role ?? 'link'}
      {...props}
    />
  );
};

export default MaskedLink;
